import { Base } from '@master/model/Base'

export class BundleQuota {
  total = 0
  used = 0
  remaining = 0
}

export class DisignPlan extends Base {
  planName = ''
  planQuota = 0
  used = 0
  active = false
  type = ''
  remaining = 0
  currentPeriodStart = 0
  currentPeriodEnd = 0
  bundleQuotas: BundleQuota = null
}
